import { useCurrentUserContext } from '../../../providers/current-user-provider/current-user-provider';
import { getDefaultObservationsConfig } from '../../app-config/app-config-root-locations/root-location-config-features/root-location-config-observations/utils';

import { useObservationConfigQuery } from './use-query/use-observation-config-query';

export const useObservationConfigByLocation = (
  rootLocationExternalId?: string
) => {
  const { data: observationConfig, isSuccess } = useObservationConfigQuery();
  const { user: userData } = useCurrentUserContext();
  const userLocationPreference = userData?.preferences?.infield?.location;

  const rootLocationToCompareTo =
    rootLocationExternalId ||
    userLocationPreference?.externalId ||
    userLocationPreference?.assetExternalId;

  const matchingConfig = observationConfig?.find(
    ({ rootLocationExternalIds }) =>
      rootLocationExternalIds.includes(rootLocationToCompareTo || '')
  );

  const defaultRootLocationConfig = getDefaultObservationsConfig(
    rootLocationToCompareTo || ''
  );

  return {
    observationConfig: matchingConfig,
    defaultObservationConfig: defaultRootLocationConfig,
    isSuccess,
  };
};
